

function getDepreciationDates(startDate, duration, isYears = false) {
  // Convert startDate string to a Date object
  let start = new Date(startDate);
  let dates = [];
  
  if (isYears) {
      // Loop through the number of years
      for (let i = 0; i < duration; i++) {
          // Create a new date object for each year
          let date = new Date(start.getFullYear() + i, start.getMonth(), start.getDate());
          
          // Check if the date is valid, if not adjust to the last day of the month
          while (date.getMonth() !== start.getMonth()) {
              date.setDate(date.getDate() - 1);
          }
          
          dates.push(new Date(date).toLocaleDateString());
      }
  } else {
      // Calculate total number of months
      let totalMonths = duration;
      
      // Loop through the total number of months
      for (let i = 0; i < totalMonths; i++) {
          // Create a new date object for each month
          let date = new Date(start.getFullYear(), start.getMonth() + i, start.getDate());
          
          // Check if the date is valid, if not adjust to the last day of the month
          while (date.getMonth() !== (start.getMonth() + i) % 12) {
              date.setDate(date.getDate() - 1);
          }
          
          dates.push(new Date(date).toLocaleDateString());
      }
  }
  
  return dates;
}

export default getDepreciationDates;